import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

Vue.config.productionTip = false;

// router.afterEach((to, from) => {
//   // const toDepth = to.path.split("/").length;
//   // const fromDepth = from.path.split("/").length;
//   const toName = to.name;
//   const fromName = from.name;
//   // const transiName = toName != fromName ? "slide" : "fade";
//   // const transiName = fromName == "home" || toName == "home" ? "slide" : "fade";
//   to.meta.transitionName =
//     toName == "overlay" || fromName == "overlay" ? "slide" : "fade";
//   // console.log(to.meta.transitionName);
// });
// router.afterEach((to, from) => {
//   from.meta.transitionName = "slide";
//   to.meta.transitionName = "slide";
//   // console.log(to.meta.transitionName);
// });

Vue.filter("truncate", function(text, stop, clamp) {
  return text.slice(0, stop) + (stop < text.length ? clamp || "..." : "");
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
